import { useCallback, useState } from "react";
import { useGlobalContext } from "../Context/GlobalContext";

export const useCategory = () => {
  const { api } = useGlobalContext();

  const [categories, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [categoryError, setCategoryError] = useState("");

  const getCategories = useCallback(
    async ({ limit = 8, offset = 0 } = {}) => {
      if (!api) {
        throw new Error("API instance is not available.");
      }

      try {
        setCategoryLoading(true);
        setCategoryError("");

        const payload = {
          limit: "0",
          offset: "0",
        };

        const response = await api.post("/Chaafo/categoryGet", payload);

        const responseData = response?.data;

        if (String(responseData?.responseCode) !== "00") {
          const message =
            responseData?.responseMessage || "Unable to fetch categories.";

          setCategories([]);
          setCategoryError(message);

          return {
            success: false,
            data: [],
            message,
          };
        }

        const categoryList = Array.isArray(responseData?.response)
          ? responseData.response
          : [];

        setCategories(categoryList);

        return {
          success: true,
          data: categoryList,
          message: responseData?.responseMessage || "",
        };
      } catch (error) {
        console.error(
          "Category Get API Error:",
          error?.response?.data || error,
        );

        const responseData = error?.response?.data;

        const message =
          typeof responseData === "object"
            ? responseData?.responseMessage ||
              responseData?.message ||
              "Unable to fetch categories."
            : error?.message || "Unable to fetch categories.";

        setCategories([]);
        setCategoryError(message);

        return {
          success: false,
          data: [],
          message,
        };
      } finally {
        setCategoryLoading(false);
      }
    },
    [api],
  );

  return {
    categories,
    setCategories,
    getCategories,
    categoryLoading,
    categoryError,
    setCategoryError,
  };
};
